export { default as InsuredsListItem } from './InsuredsListItem';
